<template>
<div v-loading.fullscreen.lock="loading" >
	<el-dialog title="发票地址信息" :show-close="false" :visible.sync="dialogVisible" width="1080px" >
			<div class="dizhi_box">
				<div v-for="(item,i) in invoiceList" :key="item.id" @click="setTake2(i)" :class="{'dizhi_zi_chon':billIndex==i}" class="dizhi_zi  clearfloat">
					<span class="flo_lf">
						{{item.province_name}}
						{{item.city_name}}
						{{item.area_name}}
						{{item.address}}
						{{item.phone}}
					</span>
					<div class="dizhi_right">
						<span  v-if="item.is_default != 1"
						@click.stop="setdihzimor(item.id)">设为默认地址</span>
						<span @click="xin.goUrl('/personalCenter/site')">编辑</span>
					</div>
				</div>
			</div>
			<div class="clearfloat hnda">
				<div class="flo_right asd" @click="addsite=true">
					新增收货地址
				</div>
			</div>
		</el-dialog>
	<div v-if="isval" class="msg_box">
		<div class="box_aqa">
			<h3>很抱歉，您查看的商品找不到了！</h3>
			<div class="aqa_zi">
				<p>您可以:</p>
				<div>1.检查刚才的输入</div>
				<div>2.去其他地方逛逛：<span class="lan" @click="xin.goUrl('/index')">首页</span></div>
			</div>
		</div>
	</div>
	<div v-else ref="boxs" class="msg_box">
		<div class="arrow_box clearfloat">
			<span class="arrow_ywz">您的位置：</span>
			<div class="arrow">
				<span class="to" @click="xin.goUrl('/index')">首页</span>
				<span class="el-icon-arrow-right"></span>
				<span class="to" @click="xin.goUrl('/integral')">积分兑换</span>
				<span class="el-icon-arrow-right"></span>
				<span class="topc">确认订单</span>
			</div>
		</div>
		<div class="integral_box clearfloat">
			<div class="inte_imgs flo_lf">
				<img :src="goods_info.cover_img" alt="">
			</div>
			<div class="inte_msg flo_lf" v-if="goods_info.type">
				<div>
					<div class="tech_title">商品名称：{{goods_info.title}}</div>
					<div class="inte_number">
						需要积分：<span>{{goods_info.type.value}}积分</span>
					</div>
				</div>
				<div class="init_bottom">
					<span>数量</span>
					<el-input-number @input="setNumber" :precision="0" :min='1' :max="999" size="mini" v-model="num4"></el-input-number>
					<span>兑换总积分：{{num4*goods_info.type.value}}积分</span>
				</div>
			</div>
		</div>
		<div class="dizhi ">
			<div class="dizhi_title">确认收票地址</div>
			<div class="site_zi" >
				<!-- <template v-if="address"> -->
					<div class="site_form clearfloat">
						<div class="form_left">单位:</div>
						<div class="form_right">{{address.unit}}</div>
					</div>
					<div class="site_form clearfloat">
						<div class="form_left">收货人:</div>
						<div class="form_right">{{address.realname}}</div>
					</div>
					<div class="site_form clearfloat">
						<div class="form_left">地区:</div>
						<div class="form_right">
							{{address.province_name}}
							{{address.city_name}}
							{{address.area_name}}
						</div>
					</div>
					<div class="site_form clearfloat">
						<div class="form_left">详细地址:</div>
						<div class="form_right">{{address.address}}</div>
					</div>
					<div class="site_form clearfloat">
						<div class="form_left">手机:</div>
						<div class="form_right">{{address.phone}}</div>
					</div>
					<div class="site_form clearfloat">
						<div class="form_left">或固定电话:</div>
						<div class="form_right">{{address.tel}}</div>
					</div>
				<!-- </template> -->
				<div><span class="lan xiahuanxa xiahuanxa" @click="dialogVisible = true">
						+使用新地址
					</span>
				</div>
			</div>
		</div>
		<div class="clearfloat">
			<button  class="laing_btn flo_right" @click="addOrder">提交</button>
		</div>
	</div>
		<!-- 添加地址 -->
		<el-dialog title="添加地址" :visible.sync="addsite" width="600px" :before-close="closeform" :close-on-click-modal="false" >
		<div>
			<el-form :model="addruleForm" :rules="rules" ref="adddizhi" label-width="130px" class="demo-ruleForm">
				<el-form-item label="单位" prop="unit">
					<el-autocomplete style="width:100%" class="inline-input" v-model="addruleForm.unit" :fetch-suggestions="querySearch"
					placeholder="试试搜索：清华" :trigger-on-focus="false"  @select="handleSelect" >
						<template slot-scope="{ item }">
							<div class="name">{{ item.name }}</div>
						</template>
					</el-autocomplete>
				</el-form-item>
				<el-form-item label="收货人" prop="realname">
					<el-input v-model="addruleForm.realname"></el-input>
				</el-form-item>
				<el-form-item label="地区" prop="addrid">
					<el-cascader style="width:100%" v-model="addruleForm.addrid" placeholder="试试搜索：上海市" :options="region"
						filterable expand-trigger="hover" clearable>
					</el-cascader>
				</el-form-item>
				<el-form-item label="详细地址" prop="address">
					<el-input v-model="addruleForm.address"></el-input>
				</el-form-item>
				<el-form-item label="手机" prop="phone">
					<el-input v-model="addruleForm.phone"></el-input>
				</el-form-item>
				<el-form-item label="或者固定电话" prop="tel">
					<el-input v-model="addruleForm.tel"></el-input>
				</el-form-item>
				<el-form-item label="设为默认地址" prop="is_default">
					<el-switch v-model="addruleForm.is_default"></el-switch>
				</el-form-item>
			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="closeform('')">取 消</el-button>
			<el-button type="primary" @click="adddizhi">确 定</el-button>
		</span>
	</el-dialog>
</div>
</template>

<script>
import city from '@/utlis/city.js'
	export default{
		data(){
			return {
				addsite:false,//添加地址
				loading:true,
				isval:false,
				goods_id:0,
				num4:1,
				dialogVisible:false,
				goods_info:{},
				address:{},
				invoiceList:[],//发票地址
				billIndex:0,
				region: [],// 地址三级
				addruleForm:{
					realname:'',//姓名
					phone:'',//电话
					address:'',//详细地址
					tel:'',//固定电话
					addrid:'',//地址
					is_default:0,//是否设为默认地址
					unit:'',//单位
				},
				rules:{
					realname:{ required: true, message: '请输入姓名', trigger: 'blur' },
					phone: { required: true, message: '请输入手机号', trigger: 'blur' },
					// tel:{ validator: validatePass, trigger: 'blur' },
					addrid:[{type: 'array', required: true, message: '请选择地区', trigger: 'change' }],
					address:{ required: true, message: '请输入详细地址', trigger: 'blur' },
					unit:{ required: true, message: '请输入单位', trigger: 'blur' },
				},
			}
		},
		created(){
			let id = this.$route.query.id;
			this.goods_id = id;
			this.PostGoods_coupon(id);
			this.Postaddressget();
			this.region = this.asd(city.data||[])
		},
		watch:{
			$route(to,fo){
				let id = to.query.id;
				this.goods_id = id;
				this.PostGoods_coupon(id);
			}
		},
		methods:{
			setNumber(str){
				if(!str){
					this.num4 = ' ';
				}
			},
			closeform(done) {//关闭添加地址
				this.$refs.adddizhi.resetFields();
				if(done) done();
				this.addsite = false;
			},
			async querySearch(queryString, cb) {//单位搜索
				let {data} = await this.api.Postuserunit({title:queryString})
				cb(data);
			},
			handleSelect(e){//添加选择单位
				this.addruleForm.unit = e.name;
			},
			adddizhi(){//添加地址
				this.$refs.adddizhi.validate(async (valid) => {
				if (!valid) return;
				let dizhi = '';
				let addruleForm = Object.assign({},this.addruleForm);
					addruleForm.addrid.forEach(v=>{
						dizhi+=v+',';
					})
					addruleForm.addrid = dizhi;
					this.istone = addruleForm.is_default;
					addruleForm.is_default = addruleForm.is_default?1:0;
					let {code} = await this.api.Postaddressadd(addruleForm);
					if(code==200){
						this.$message({ message: '地址添加成功', type: 'success' });
						this.closeform('');
						this.Postaddressget();
						// this.invoice = Object.assign({},this.siteList[0]);
						// this.address = Object.assign({},this.siteList[0]);
					}
				});
			},
			asd(list){//遍历
				return list.map((v,i)=>{
					v.label = v.name;
					// delete v.name;
					v.value = v.id;
					if(v.datas){
						v.children = this.asd(v.datas);
						delete v.datas;
					}
					return v;
				})
			},
			async addOrder(){//提交订单

				if(!this.address.unit){
					this.$message({ message: '请选择发票地址', type: 'warning' });
					return;
				}
				this.loading = true;
				let {code,data} = await this.api.PostcreateOrder({
					goods_id:this.goods_id,
					number:this.num4,
					address_id:this.address.id
				});
				if(code==200)
					this.xin.goUrl('/integralOredr?order_id='+data.order_id);
				this.loading = false;
			},
			async Postaddressget(){//获取地址列表
				let {data} = await this.api.Postaddressget();
				if(this.istone)
					data.data.forEach((v,i) => {
						if(v.is_default==1){
							this.billIndex = i;
						}
					});
				else this.istone = true;
				this.invoiceList = data.data;
				return data.data;
			},
			setTake2(i){//发票地址选择
				this.dialogVisible = false;
				this.billIndex = i;
				this.address = Object.assign({},this.invoiceList[i]);
			},
			async setdihzimor(address_id){//设为默认地址
				let {code} = await this.api.Postaddresssetdefault({address_id});
				let dizhi = await this.Postaddressget();
				this.dialogVisible = false;
				this.address = dizhi[0];
			},
			async PostGoods_coupon(integral_id){//获取积分商品详情
				if(!integral_id){
					this.isval = true;
					return;
				}
				this.loading = true;
				let {data,code} = await this.api.PostGoods_coupon({integral_id});
				if(data.goods_info){
					this.goods_info = data.goods_info;
					this.address = data.address||{};
				}else this.isval = true;
				this.loading = false;
			},
		}
	}
</script>

<style lang="scss" scoped>
.hnda{
	margin: 20px 0;
}
.clearfloat{
	.asd{
		font-size: 24px;
		font-weight: 600;
		text-decoration: underline;
		color: #333333;
		line-height: 19px;
		cursor: pointer;
	}
}
	.dizhi_box{
		.dizhi_zi{
			border: 1px solid #fff;
			height: 50px;
			padding: 0 20px;
			line-height: 50px;
			box-sizing: border-box;
			cursor: pointer;
			.dizhi_right{
				float: right;
				span{
					margin-left: 10px;
				}
			}
			&:hover{
				// color: #fff;
				border:1px solid var(--themeColor);
			}
		}
		.dizhi_zi_chon{
			background: #005599;
			color: #fff;
			
		}
	}
.dizhi{
		
		margin-top: 50px;
		.dizhi_title{
			margin-bottom: 20px;
			font-size: 20px;
			color: #333333;
			line-height: 6px;
		}
		.lan{
			font-size: 20px;
		}
	}
	.site_zi{
		padding-left: 40px;
		margin-bottom: 40px;
		border-top: 1px solid #F2F2F2;
		.site_title{
			font-size: 24px;
			color: #333;
			.lan{
				color: var(--themeColor);
				margin-left: 60px;
			}
		}
		.site_form{
			margin: 20px 0;
			.form_left{
				width: 100px;
				float: left;
				height: 30px;
				line-height: 30px;
				color: #333333;
			}
			.form_right{
				float: left;
				color: #666;
				input{
					color: #666;
					height: 30px;
					border: 1px solid #D9D9D9;
					width: 280px;
				}
				.form_select{
					width: 110px;
					margin-left: 10px;
				}
				select{
					color: #666;
					box-sizing: content-box;
					height: 34px;
					border: 1px solid #D9D9D9;
					width: 286px;
				}
			}
		}
	}
.integral_box{
	// margin:  0 auto;
	// width: 800px;
	border-bottom: #D9D9D9 1px solid;
	padding-bottom: 60px;
	.inte_imgs{
		
		margin-left: 200px;
		img{
			width: 400px;
			height:300px;
		}
	}
	.inte_msg{
		color: #333;
		margin-left: 30px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 300px;
		.inte_number{
			margin: 10px 0;
			span{
				color: #B03130;
				font-size: 24px;
				line-height: 16px;
			}
		}
		.init_bottom{
			span{
				margin: 0 5px;
			}
		}
		.tech_title{
			margin-top: 0;
		}
	}
}
</style>
